// extracted by mini-css-extract-plugin
module.exports = {"magicLabel":"idt-magiclabelicon_magiclabel__11xcn"};